<app-bread-crumb [items]="[{text:  'produtos',link:'/admin/stock/list'},{text:'detalhe'}]"
  [sectionTitle]="'Detalhe'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-6">
      <!-- Profile Image -->
      <div class="box box-success" style="border-top: 2px solid #f35309;">

        <div class="box-body box-profile">

          <img 
            class="img-responsive" 
            style="width:250px ;height:250px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;" 
            [src]="stock.image || 'http://localhost:4200/assets/Khuzela.png'"
            alt="imagem do parceiro">

          <ul class="list-group list-group-unbordered" style="margin-top: 10px;">

            <li class="list-group-item">
<!-- 
              <div class="upload-btn-wrapper">

                <button class="btn btn-outline-danger btn-block">
                  <i class="fa fa-cloud-upload"></i>Carregar Mais Imagens
                </button>
    
                <input title="" multiple maxLength="3" type="file" #iptFile (input)="updateImageProfile($event,stock)"/>

              </div> -->

                <button type="button" class="btn btn-outline-danger form-control" data-toggle="modal"
                data-target="#modal-default">
                        <i class="fa fa-cloud-upload"></i> Carregar mais imagens
                </button>
            </li>

          </ul>

        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->

      <div class="row">
          <div class="col-md-12">
              <div class="box">
                  <div class="box-body">

                      <div class="row">

                        <ng-container *ngIf="stock.images.length !== 0">

                            <div class="col-md-4" *ngFor="let imageFile of stock.images">

                               

                                <div class="upload-btn-wrapper">

                                    <img 
                                        class="img-responsive" 
                                        style="width:100px ;height:100px ; margin:0 auto;border-radius:50%;border:1px solid #f7814a;" 
                                        [src]="imageFile.image || 'http://localhost:4200/assets/Khuzela.png'"
                                        alt="imagem do produto do stock">

                                    <input  title="Clique para alterar a imagem" type="file" (change)="updateImage($event,imageFile)" />

                                </div>
                    
                            </div>

                        </ng-container>

                         <div class="col-md-12" *ngIf="stock.images.length===0">
                            <h3 class="text-center text-danger">Não exitem imagem adicionais! carregue no botão acima para adicionar 3 imagens.</h3>
                        </div>

                      </div>

                  </div>
              </div>
          </div>
      </div>
    </div>


    <div class="col-md-6">

      <div class="box box-widget widget-user-2" style="border-top: 2px solid #f35309;">

        <div class="box-footer no-padding">
          <ul class="nav nav-stacked">
            <li><a href="javascript:void(0);"><strong>Código</strong> <span class="pull-right"><strong class="text text-warning" [ngStyle]="{fontSize:'14px'}">{{stock?.product_code}}</strong></span></a></li>
            <li><a href="javascript:void(0);"><strong>Título</strong> <span class="pull-right">{{stock?.productName}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Descrição</strong> <span class="pull-right">{{stock?.productDescription}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Categoria</strong> <span class="pull-right">{{stock?.category}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Subcategoria</strong> <span class="pull-right">{{stock?.subcategory}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Cor</strong> <span class="pull-right"><label class="label label-warning" [ngStyle]="{fontSize:'14px'}">{{stock?.colorDescription}}</label></span></a></li>
            <li><a href="javascript:void(0);"><strong>Tamanho</strong> <span class="pull-right"><label class="label label-warning" [ngStyle]="{fontSize:'14px'}">{{stock?.size}} - {{stock?.sizeDescription}}</label></span></a></li>
            <li><a href="javascript:void(0);"><strong>Stock Existente</strong> <span class="pull-right"><label class="label label-success" [ngStyle]="{fontSize:'14px'}">{{stock?.quant_total}}</label></span></a></li>
            <li><a href="javascript:void(0);"><strong>Preço</strong> <span class="pull-right" [ngStyle]="{fontSize:'14px'}">{{stock?.price | currency:'MZN':'symbol'}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Estado</strong> <span class="pull-right text-success">{{stock?.statusName}}</span></a></li>
            <li><a href="javascript:void(0);"><strong>Clube</strong> <span class="pull-right" [ngStyle]="{color: stock?.clubColor,padding:'2px'}"><strong>{{stock?.clubName || 'Sem clube definido'}}</strong></span></a></li>
            <li class="botao">
              <button type="button" (click)="editStock(stock)" class="btn btn-outline-danger pull-right"><strong><i
                    class="fa fa-edit"></i> Editar</strong></button>
            </li>
          </ul>

        </div>

      </div>

    </div>

  </div>

  <!-- Modal -->
  <div class="modal fade" id="modal-default">
            
    <div class="modal-dialog" style="width: 60%;">

        <div class="modal-content">

            <div class="modal-header">

                <div class="upload-btn-wrapper text-center">
                    <button class="btn2 form-control"> <i class="fa fa-download"></i> Clique aqui para carregar imagens</button>
                    <input title="" multiple type="file"  (input)="previewSelectedImages($event)" />
                </div>

            </div>

            <div class="modal-body">


                <div class="info-div">

                    <div class="row">

                        <ng-container *ngIf="arrayOfimagesUrls.length!==0; else mostrarMensagem">

                            <div class="col-md-3" *ngFor='let url of arrayOfimagesUrls;'>
                                <button class="fa fa-close pull-right btn btn-xs btn-danger"
                                    (click)="removeSelectedImage(url)"></button>
                                <img [src]="url" width="250" height="200" class="img-responsive">
                            </div>

                        </ng-container>

                        <ng-template #mostrarMensagem>
                            <h3 class="text-center text-danger">Nenhuma imagem selecionada, clique no botão acima para selecionar as imagens!</h3>
                        </ng-template>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button type="button" data-dismiss="modal" class="btn btn-secondary pull-left">
                    <i class="fa fa-close"></i> SAIR
                </button>

                <button [disabled]="arrayOfimages.length == 0" type="button" (click)="removeAllSelectedImages()" class="btn btn-danger pull-left">
                    <i class="fa fa-close"></i> REMOVER TODAS IMAGENS
                </button>

                <ng-button (click)="saveImagesOfStock()" class="pull-right" [button]="{
                  name:'salvar',
                  color:'danger',
                  faIconClass:'fa fa-save',
                  type:'submit',
                  loadingText:'SALVANDO',
                  isLoading:isButtonLoading,
                  isDisabled:arrayOfimages.length == 0 || isButtonLoading}">
              </ng-button>

            </div>

        </div>

        <!-- /.modal-content -->

    </div>

    <!-- /.modal-dialog -->

</div>
<!-- /.fim modal -->

</section>